// extracted by mini-css-extract-plugin
module.exports = {"LoadingIndicator":"LoadingIndicator_LoadingIndicator__3hGhB"};